<template>
<section>
    <div class="wrap">
        <div class="model_name_div">
            <dl class="model_name">
                <dt>{{trimItem.name}}</dt>
                <!-- <dt>{{trimItem.content}}</dt> -->
            </dl>
            <img :src="trimItemModelAttUrl" style="margin-right:0">
            
        </div>
        <div class="find_consultant_info">
            <ReviewList
                filterChk
                v-model="score"
                :items="reviewItems" 
                :totalCount="totalCount"
            />
        </div>
    </div>

</section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ReviewList from '../../components/review/ReviewList.vue';
import { InfinityScrollMixin } from '../../mixins/InfinityScrollMixin';

export default {
    name:'VehicleReview',
    
    mixins: [ InfinityScrollMixin ],

    components:{
        ReviewList
    },

    data() {
        return {
            score: '',
            trimItem: {},
        }
    },

    computed: {
        ...mapState({
            brandItems: state => state.brand.items,
            bookingWrite: state => state.booking.itemWrite,
        }),

        ...mapGetters([
            'viewModelAttUrl',
        ]),

        trimId() {
            return this.$route.params.trimId;
        },
        
        trimItemModelAttUrl(){
            return this.viewModelAttUrl((this.trimItem.modelAtt) ? this.trimItem.modelAtt.url : null);
        },
        
    },

    watch: {
        score() {
            this.$store.commit('CLEAR_REVIEW_LIST');
            this.changeSearchOption();
        }
    },

    created () {
        this.$store.dispatch('GET_TRIM', this.trimId)
        .then((data) => {
            this.trimItem = data;
            this.setScroll();
            this.getContentList();
            this.$store.commit('SHOW_ONLOAD');
        });
    },

    destroyed() {
        this.removeScroll();
    },

    methods: {        
        getContentList() {

            if(this.reviewItems.length < this.totalCount || this.page == 0) {
                this.$store.dispatch(
                    'GET_REVIEW_LIST_PAGE',
                    {
                        trimId: this.trimId,
                        hasContent: 1,
                        score: this.score,
                        page: this.page++,
                        size: this.limit
                    }
                )
                .then(() => {
                    this.scrollPause = false;
                });
            }
            else {
                this.doneFlag = true;
            }
        },
    }
    
}
</script>

<style>
    .customer_reviews {
        margin-top:15px
    }
</style>